import React from 'react';
import PropTypes from 'prop-types';
import { BoldTitle, SubTitle } from '../../CustomizedComponents/Texts';
import SectionWrapper from '../../CardRow/SectionWrapper';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';

const TextFieldWrapper = styled.div`
    width: '100%';
    display: 'flex';
`;

const getTitleProduct = ( type ) => {
  switch (type) {
    case 'ANNUAL':
      return 'app.configuration.period.product.year';
    case 'MONTH':
      return 'app.configuration.period.product.month';
    case 'QUARTAL':
      return 'app.configuration.period.product.quarter';
    default:
      return '';
  }
};

const getPanel = ( value, editable, title, handler, type, product) => {
  return (
    <CustomTextField
      style={{ width: '27%' }}
      value={value}
      name={product}
      onChange={
        (event) => {
          const target = event.target;
          handler((oldState) => {
            const newState = [...oldState];
            const foundValue = newState.find((value) => {
              return (value.productType === product);
            });
            foundValue[type] = target.value;
            return newState;
          });
        }
      }
      label={<FormattedMessage id={title} />}
      disabled={!editable}
      InputProps={{
        inputComponent: CustomNumberFormat,
      }}
      variant="outlined"
    />
  );
};

const PurchaseStep = (
  {
    purschaseStep,
    handler,
    editable,
  } ) => {
  const bestAskTitle = 'app.configuration.purchase.bestAsk';
  const settlementTitle = 'app.configuration.purchase.settlement';
  const minTitle = 'app.configuration.MWhMin';
  const maxTitle = 'app.configuration.MWhMax';
  return (
    <>
      {purschaseStep&&purschaseStep.map((step) => (
        <SectionWrapper key={step.productType}>
          <BoldTitle title={getTitleProduct(step?.productType)} />
          <SubTitle title={bestAskTitle} />
          <TextFieldWrapper>
            {getPanel(step?.bestAskMinAmount, editable, minTitle, handler, 'bestAskMinAmount', step?.productType)}
            {getPanel(step?.bestAskMaxAmount, editable, maxTitle, handler, 'bestAskMaxAmount', step?.productType)}
          </TextFieldWrapper>
          <SubTitle title={settlementTitle} />
          <TextFieldWrapper>
            {getPanel(step?.settlementMinAmount, editable, minTitle, handler, 'settlementMinAmount', step?.productType)}
            {getPanel(step?.settlementMaxAmount, editable, maxTitle, handler, 'settlementMaxAmount', step?.productType)}
          </TextFieldWrapper>
        </SectionWrapper>
      ))}
    </>
  );
};

PurchaseStep.propTypes = {
  purschaseStep: PropTypes.any,
  editable: PropTypes.bool,
  handler: PropTypes.func,
};

export default PurchaseStep;
